import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { getPermissions } from '@/lib/roles';

/**
 * Hook che ritorna i permessi dell'utente corrente in base a ruolo e profilo.
 * Il profilo serve al gate ETO: i Fastweb territoriali (isEto !== true) perdono
 * i permessi di amministrazione accessi (canInviteUsers). Passiamo `null`
 * finché il profilo non è caricato = default sicuro (non ETO).
 */
export function usePermissions() {
  const { role, userProfile } = useAuth();
  return useMemo(() => getPermissions(role, userProfile ?? null), [role, userProfile]);
}
